export const BuilderPalChatType = {
  DISCOVERY: 'DISCOVERY',
  GUIDING: 'GUIDING',
  CONVERSATIONAL: 'CONVERSATIONAL',
  GUIDANCE: 'GUIDANCE',
  GUIDANCE_CHALLENGE: 'GUIDANCE_CHALLENGE',
};

export const builderPalChatTypes = [
  BuilderPalChatType.DISCOVERY,
  BuilderPalChatType.GUIDING,
  BuilderPalChatType.CONVERSATIONAL,
  BuilderPalChatType.GUIDANCE,
  BuilderPalChatType.GUIDANCE_CHALLENGE,
];
